import type React from 'react';
import { Tag, TagGroup, type Key } from '@heroui/react';

type FilterPickerTagsProps = {
    /** The picked values in the order they read, each with its label. */
    tags: { key: string; label: string }[];
    onRemove: (keys: Set<Key>) => void;
};

/** A filter picker's picked values, as removable tags inside the field. */
export const FilterPickerTags: React.FC<FilterPickerTagsProps> = ({
    tags,
    onRemove,
}) => (
    <TagGroup onRemove={onRemove} size="sm">
        <TagGroup.List>
            {tags.map((tag) => (
                <Tag id={tag.key} key={tag.key}>
                    {tag.label}
                </Tag>
            ))}
        </TagGroup.List>
    </TagGroup>
);
